import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

sync(store, router)

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import FirebaseAuthPlugin from './FirebaseAuthPlugin'
Vue.use(FirebaseAuthPlugin)

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA8_vo4yO_Unm6cc0kAVqPhBQ4TCynkWqA',
    libraries: 'places,directions'
  }
})

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')